/* jshint ignore:start */
if (typeof define !== 'function') {
    var define = require('amdefine')(module)
}
/* jshint ignore:end */

define('pdfGear/generator/content',['./chart', './dashboard', './zoning', './components', './const', '../localization/messages'],
    function(chart, dashboard, zoning, components, CONST, messages) {
        'use strict';

        /**
         * style to be used for showing bullet messages
         * @type {Object}
         */
        var bulletMessageStyle = {
            fontSize: 7,
            color: '#cdcdcd',
            alignment: 'left',
        };

        return {
            createDocumentContent: createDocumentContent,
            bulletMessageStyle: bulletMessageStyle
        };


        /**
         * Funciton to create content array for pdfmake. Content array loops through data for all the widgets and invoke corresponding fucntions to format individual widgets
         * @param  array of javascript objects containing raw data for all the widgets to be included in pdf
         * @return array of javascript objects formatted according to the pdfmake format
         */
        function createDocumentContent(widgets) {
            var content = [];
                //loop here on all widgets and push into  content

            widgets.forEach(function(widget, index) {
                
                if (index!==0 && index % 2 === 0){
                    content.push(components.getPageBreakElement());
                    addWidget(widget, content);
                } else {
                    addWidget(widget, content);
                }
            });

            return content;
        }
        /**
         * function to add widget according to the proper type
         * @param widget contains all the raw infomration about the widget to be added
         * @param content contains all the widgets that has been aleady added to the pdf
         */
        function addWidget(widget, content) {
            if (widget.type === CONST.TYPES.CHART) {
                //construct analytics charts
                content.push(chart.constructChart(widget));
            } else if (widget.type === CONST.TYPES.DASHBOARD) {
                //construct dashboard widgets
                content.push(dashboard.constructDashboardWidgets(widget));
            } else {
                //construct zoning widgets
                content.push(zoning.constructZoningWidget(widget));
            }
        }
    });
